import ExceptionPage from "../../components/exception-page/ExceptionPage";

function NF500() {

    return (
        <ExceptionPage showHomebutton title={'500'} subTitle={'API Access Failed'} description={"You do not have this part of the service."}/>
    );
}

export default NF500;